var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"yotpo yotpo-main-widget overflow-hidden",attrs:{"data-product-id":_vm.yotpoId,"data-name":_vm.yotpoName,"data-url":_vm.dataURL,"data-mode":"questions"}})
}
var staticRenderFns = []

export { render, staticRenderFns }